import { createAction } from 'redux-actions';
import Types from './types';

export const getDashboardRequest = createAction(
  Types.GET_DASHBOARD_DATA_REQUEST
);
export const getDashboardFulfilled = createAction(
  Types.GET_DASHBOARD_DATA_FULFILLED
);
export const getDashboardRejected = createAction(
  Types.GET_DASHBOARD_DATA_REJECTED
);

export const getDashboardPartnerRequest = createAction(
  Types.GET_DASHBOARD_DATA_PARTNER_REQUEST
);
export const getDashboardPartnerFulfilled = createAction(
  Types.GET_DASHBOARD_DATA_PARTNER_FULFILLED
);
export const getDashboardPartnerRejected = createAction(
  Types.GET_DASHBOARD_DATA_PARTNER_REJECTED
);

export const getIncidentPanelDataRequest = createAction(
  Types.GET_INCIDENT_PANEL_DATA_REQUEST
);
export const getIncidentPanelDataFulfilled = createAction(
  Types.GET_INCIDENT_PANEL_DATA_FULFILLED
);
export const getIncidentPanelDataRejected = createAction(
  Types.GET_INCIDENT_PANEL_DATA_REJECTED
);

export const getPartnerDataGraphRequest = createAction(
  Types.GET_PARTNER_DATA_GRAPH_REQUEST
);
export const getPartnerDataGraphFulfilled = createAction(
  Types.GET_PARTNER_DATA_GRAPH_FULFILLED
);
export const getPartnerDataGraphRejected = createAction(
  Types.GET_PARTNER_DATA_GRAPH_REJECTED
);

export const setPartnerDataPeriodFilter = createAction(
  Types.SET_PARTNER_DATA_PERIOD_FILTER
);

export const setPartnerDataPeriodCardFilter = createAction(
  Types.SET_PARTNER_DATA_PERIOD_CARD_FILTER
);

export const getDataDashboardHistoryRequest = createAction(
  Types.GET_DATA_DASHBOARD_HISTORY_REQUEST
);
export const getDataDashboardHistoryFulfilled = createAction(
  Types.GET_DATA_DASHBOARD_HISTORY_FULFILLED
);
export const getDataDashboardHistoryRejected = createAction(
  Types.GET_DATA_DASHBOARD_HISTORY_REJECTED
);

export const getPartnerEnvironmentsCostGraphRequest = createAction(
  Types.GET_PARTNER_ENVIRONMENTS_COST_GRAPH_REQUEST
);
export const getPartnerEnvironmentsCostGraphFulfilled = createAction(
  Types.GET_PARTNER_ENVIRONMENTS_COST_GRAPH_FULFILLED
);
export const getPartnerEnvironmentsCostGraphRejected = createAction(
  Types.GET_PARTNER_ENVIRONMENTS_COST_GRAPH_REJECTED
);
export const setPartnerEnvironmentsCostPeriodFilter = createAction(
  Types.SET_PARTNER_ENVIRONMENTS_COST_PERIOD_FILTER
);
